
import { Component } from 'vue-property-decorator';
import StickyFilterContainer from '@/components/reports-v3/components/pages/StickyFilterContainer.vue';
import YTDPurchaseNumberDisplayer from '@/components/reports-v3/components/codedWidgets/purchase/PurchaseYtdPurchaseNumberDisplayer.vue';
import MonthPurchaseNumberDisplayer from '@/components/reports-v3/components/codedWidgets/purchase/PurchaseCurrentMonthPurchaseNumberDisplayer.vue';
import userx from '@/store/modules/userx';
import router from '@/router';
import moment from 'moment';
import DateFilter from '@/components/reports-v3/components/filters/DateFilter.vue';
import gdbx from '@/store/modules/gdbx';
import LastSync from '@/components/LastSync.vue';
import StockItemPurchaseBySupplierTable from '@/components/reports-v3/components/codedWidgets/shared/SharedStockItemPurchaseBySupplierTable.vue';
import BasePageContainer from '../BasePageContainer.vue';
import SupplierPurchaseTrendBarLineChart from '@/components/reports-v3/components/codedWidgets/purchase/PurchaseTrendBarLineChart.vue';

@Component({
	components: {
		YTDPurchaseNumberDisplayer,
		MonthPurchaseNumberDisplayer,
		StickyFilterContainer,
		DateFilter,
		LastSync,
		StockItemPurchaseBySupplierTable,
		SupplierPurchaseTrendBarLineChart,
	},
})
export default class PurchaseOverview extends BasePageContainer {
	public selectedDay: number = moment().endOf('day').valueOf();

	public mounted() {
		this.track();
	}

	public track() {
		this.$ga.set('userId', userx.user!.uid + '_' + userx.user!.email);
		this.$ga.page(router);
	}

	public get selectedAsOfDate() {
		return moment(this.selectedDay).endOf('month').valueOf();
	}

	public get selectedCurrentMonthRange(): [number, number] {
		return [
			moment(this.selectedDay).startOf('month').valueOf(),
			moment(this.selectedDay).endOf('month').valueOf(),
		];
	}

	public get currentYearRange(): [number, number] {
		return [
			moment(this.selectedDay).startOf('year').valueOf(),
			moment(this.selectedDay).endOf('year').valueOf(),
		];
	}

	public get selectedYearToDateRange(): [number, number] {
		return [
			moment(this.selectedDay).startOf('year').valueOf(),
			moment(this.selectedDay).endOf('month').valueOf(),
		];
	}

	public get selectedAgents() {
		return gdbx.allAgents.map((vt) => vt.value);
	}

	public get selectedStockItems() {
		return gdbx.allStockItems.map((vt) => vt.value);
	}

	public get selectedSuppliers() {
		return gdbx.allSuppliers.map((vt) => vt.value);
	}

	public onHovering(value: boolean, filterId: string) {
		this.$emit('hovering', value, filterId);
	}
	public onEditing(value: boolean, filterId: string) {
		this.$emit('editing', value, filterId);
	}
}
